import React from 'react';
import { Link } from "react-router-dom";
import { Container } from './styles';

const NotFoundScreen = () => {
  return (
    <Container>
      <div className='content'>
        <div className='errorCode'>404</div>
        <h1 className='title'>Page Not Found</h1>
        <p className='message'>
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className='homeLink'>
          Return to Homepage
        </Link>
      </div>
    </Container>
  );
};

export default NotFoundScreen;